export enum PlayerFocusElement {
  Playhead,
  WallClock,
}
